import { CouponType } from "../../../constants";

export const getCouponDescriptionByType = (couponType: CouponType) => {
  switch (couponType) {
    case CouponType.SharingCoupon:
      return "Reward resellers for sharing a set number of products.";
    case CouponType.QuantityResoldCoupon:
      return "Reward resellers for reselling a specific quantity of products.";
    case CouponType.AmountResoldCoupon:
      return "Reward resellers for reselling products at a specific value.";
    case CouponType.OrdersResoldCoupon:
      return "Reward resellers for reselling a specific quantity of orders.";
    case CouponType.SpendAndSaveCoupon:
      return "Offer discounts based on the total cart value at checkout.";
    case CouponType.CustomCoupon:
      return "Coupons that can be applied only by manual entering the code.";
    default:
      return "";
  }
};
